import React from "react";
import { getSourceImageUrlToCGI } from "../../utils/base";
import { Link } from "../../utils/customLink";
import Image from "../../components/image";
import QuoteMarkStart from "../../images/blog/quote-start.png";
import QuoteMarkEnd from "../../images/blog/quote-end.png";

const BlogQuoteBlock = ({ post }) => {
  const quoteImageMain =
    getSourceImageUrlToCGI({ uri: post?.blogBquoteImageMain?.sourceUrl }) ?? "";
  const quoteImageInsert =
    getSourceImageUrlToCGI({ uri: post?.blogBquoteImageInsert?.sourceUrl }) ??
    "";
  const quoteSummary = post?.blogBquoteSummary ?? "";
  const quoteCtaTitle = post?.blogBquoteCtaTitle ?? "";
  const quoteCtaLink = post?.blogBquoteCtaLink ?? "";

  return (
    <div className="w-full">
      <div className="flex items-center justify-center gap-2">
        <div className="w-7/12">
          <p className="text-2xl italic font-light text-black-lighter planet:text-white">
            <span className="w-[40px] h-[40px] float-left">
              <Image
                imageAlt="Quote mark"
                image={""}
                imageClass="w-full h-full bg-center bg-cover object-cover object-center"
                sourceUrl={QuoteMarkStart}
              />
            </span>
            <div
              className="text-2xl italic font-light text-black-lighter planet:text-white"
              dangerouslySetInnerHTML={{ __html: quoteSummary }}
            />
            <span className="w-[40px] h-[40px] float-right">
              <Image
                imageAlt="Quote mark"
                image={""}
                imageClass="w-full h-full bg-center bg-cover object-cover object-center"
                sourceUrl={QuoteMarkEnd}
              />
            </span>
          </p>
          <Link
            className="flex items-center justify-center w-full h-10 px-10 mt-10 text-sm font-bold border rounded-full planet:rounded-sm view-program-link md:w-max text-black-lighter planet:text-white planet:bg-transparent border-black-lighter planet:border-white"
            to={quoteCtaLink}
          >
            <span>{quoteCtaTitle}</span>
          </Link>
        </div>
        <div className="relative w-5/12">
          <Image
            imageAlt="Written by"
            image={""}
            imageClass="w-full bg-center bg-cover object-cover object-center rounded-md"
            sourceUrl={quoteImageMain}
          />
          <div
            className="absolute w-40 h-40 bg-center bg-cover rounded-lg -top-4 -right-4"
            style={{
              backgroundImage: `url(${quoteImageInsert})`
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogQuoteBlock;
